import api from '../../../api';

import { DeleteDomainRequestPayload, GetDomainsRequestPayload } from '../types';

export const getDomains = async (payload: GetDomainsRequestPayload) =>
  api.get(`/domain`, { params: payload });

export const deleteDomain = async (payload: DeleteDomainRequestPayload) =>
  api.delete(`/domain`, { params: payload });
